module.exports = __webpack_public_path__ + "static/img/transys-thumb.ef5494f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/pjmove-thumbs/transys-thumb.jpg
// module id = YTDf
// module chunks = 0